export default __webpack_public_path__ + "static/media/favorite-empty.616d3036.svg";